import { Box, Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useRouter } from "next/router";
import { alpha } from "@mui/material/styles";
import ProfileForm from "./ProfileForm";
import { useAuth } from "@/context/AuthContext";
import { useGetMyProfessionalQuery } from "@/src/services/api";
import { rose } from "@/theme/colors";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ProfileDetailsModal({
  open,
  profile,
  profileImageUrl,
  isSaving,
  error,
  onClose,
  onSave,
  onImageUploaded
}) {
  const router = useRouter();
  const {
    isAuthenticated
  } = useAuth();
  // The signed-in user's published professional page (data:null when none).
  // Drives the "Edit My Profile" shortcut in the title row.
  const {
    data: myProfessional
  } = useGetMyProfessionalQuery(undefined, {
    skip: !open || !isAuthenticated
  });
  return /*#__PURE__*/_jsxs(Dialog, {
    open: open,
    onClose: onClose,
    fullWidth: true,
    maxWidth: "md",
    children: [/*#__PURE__*/_jsxs(DialogTitle, {
      sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2
      },
      children: [/*#__PURE__*/_jsx(Box, {
        component: "span",
        children: "Complete your profile"
      }), !!myProfessional && /*#__PURE__*/_jsx(Button, {
        variant: "outlined",
        size: "small",
        onClick: () => {
          void router.push("/professionals/create");
          onClose();
        },
        sx: {
          color: rose.primary,
          borderColor: rose.primary,
          "&:hover": {
            color: rose.dark,
            borderColor: rose.dark,
            backgroundColor: alpha(rose.primary, 0.06)
          }
        },
        children: "Edit My Profile"
      })]
    }), /*#__PURE__*/_jsx(DialogContent, {
      dividers: true,
      children: /*#__PURE__*/_jsx(ProfileForm, {
        profile: profile,
        profileImageUrl: profileImageUrl,
        isSaving: isSaving,
        error: error,
        onSave: onSave,
        onImageUploaded: onImageUploaded,
        showCancel: true,
        onCancel: onClose,
        showPublishProfile: true
      })
    })]
  });
}